import { render, staticRenderFns } from "./LightBox.vue?vue&type=template&id=3339c10e"
import script from "./LightBox.vue?vue&type=script&lang=js"
export * from "./LightBox.vue?vue&type=script&lang=js"
import style0 from "./LightBox.vue?vue&type=style&index=0&id=3339c10e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports